// extracted by mini-css-extract-plugin
export var stagesWork = "stagesWork-module--stagesWork--Ql6AP";
export var container = "stagesWork-module--container--vB0Ha";
export var img = "stagesWork-module--img--38nKj";
export var stage = "stagesWork-module--stage---N9+o";
export var number = "stagesWork-module--number--xENPN";
export var text = "stagesWork-module--text--ojFmS";